// @flow

export const messageClass = {
  MESSAGE: 'MESSAGE',
  MESSAGE_ITEM: 'MESSAGE_ITEM'
}
